import { render, staticRenderFns } from "./inboundRecordList.vue?vue&type=template&id=005994da&scoped=true&"
import script from "./inboundRecordList.vue?vue&type=script&lang=js&"
export * from "./inboundRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005994da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005994da')) {
      api.createRecord('005994da', component.options)
    } else {
      api.reload('005994da', component.options)
    }
    module.hot.accept("./inboundRecordList.vue?vue&type=template&id=005994da&scoped=true&", function () {
      api.rerender('005994da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionEquipmentMgr/stockRecordMgr/components/inboundRecordList.vue"
export default component.exports